<template>
  <v-container grid-list-lg>
    <router-view />
  </v-container>
</template>

<script>
export default {
  name: "InboundDeliveryPerson",
};
</script>
